// extracted by mini-css-extract-plugin
module.exports = {"MessageForm":"MessageForm_MessageForm__3Y3Bu"};